/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.20/esri/copyright.txt for details.
*/
const t={type:String,json:{read:{source:"token"},write:{target:"token"}}};export{t as apiKey};
